import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import TranslationENG from './assets/translations/en.json';
import TranslationES from './assets/translations/es.json';
// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: TranslationENG
    },
    es: {
        translation: TranslationES
    },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }, react: {
            useSuspense: false
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js